export const isEmailValid = (email) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email.trim());
}

export const isReportDescriptionValid = (description) => {
    return description && description.trim().length >= 10;
}

export const isReportValid = (description, email) => {
    return isReportDescriptionValid(description) && isEmailValid(email);
}